// extracted by mini-css-extract-plugin
export default {"RTEWrapper":"Editor_RTEWrapper__ViQS6"};